import React, { useState } from "react";
import "./StaticPage.css";
import "./Contact.css";
import "./Partner.css";

var BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

var PERKS = [
  { title: "Free Product Hampers", desc: "Get our full range of authentic Pahadi products delivered to your door — on us." },
  { title: "Commission on Sales", desc: "Earn attractive commissions through your personal discount code and affiliate links." },
  { title: "Featured Collabs", desc: "Get featured on our channels and grow alongside a brand rooted in authenticity." },
  { title: "Long-Term Partnerships", desc: "We value creators who love what we do — the best collabs become lasting relationships." },
];

export default function Influencer() {
  var [form, setForm] = useState({ name: "", email: "", phone: "", platform: "", handle: "", followers: "", message: "" });
  var [status, setStatus] = useState("");
  var [sending, setSending] = useState(false);
  var [errors, setErrors] = useState({});

  function validate() {
    var errs = {};
    if (!form.name.trim()) errs.name = 'Please enter your name.';
    var emailOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email);
    if (!emailOk) errs.email = 'Please enter a valid email address.';
    var digits = form.phone.replace(/\D/g, '').slice(-10);
    if (!/^[6-9]\d{9}$/.test(digits)) errs.phone = 'Please enter a valid 10-digit phone number.';
    if (!form.platform) errs.platform = 'Please select a platform.';
    if (!form.handle.trim()) errs.handle = 'Please enter your handle.';
    if (!form.followers.trim()) errs.followers = 'Please enter your follower count.';
    return errs;
  }

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    var errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setSending(true); setStatus("");
    try {
      var res = await fetch(BACKEND_URL + "/api/influencer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, type: "influencer" }),
      });
      if (res.ok) { setStatus("success"); setForm({ name: "", email: "", phone: "", platform: "", handle: "", followers: "", message: "" }); }
      else setStatus("error");
    } catch (err) { setStatus("error"); }
    finally { setSending(false); }
  }

  return (
    <div className="static-page">
      <div className="partner-hero">
        <div className="partner-hero-inner">
          <span className="section-label">Creator Collaboration</span>
          <h1>Create with PureJar</h1>
          <p>Love authentic food and telling real stories? Partner with us to share the taste of the mountains with your community.</p>
          <a href="#influencer-form" className="btn-primary">Apply to Collaborate</a>
        </div>
      </div>

      <div className="partner-section">
        <div className="partner-intro">
          <h2>Real products, real stories</h2>
          <p>
            We're looking for creators who care about authenticity as much as we do — food lovers, home cooks,
            wellness advocates, and storytellers who want to share genuine Pahadi products with their audience.
            Whether you have 2,000 followers or 200,000, if your community trusts your voice, we'd love to talk.
          </p>
        </div>
      </div>

      <div className="partner-section partner-benefits-section">
        <div className="partner-container">
          <h2 className="partner-section-title">What you get</h2>
          <div className="partner-benefits">
            {PERKS.map(function(p, i) {
              return (
                <div key={i} className="partner-benefit-card">
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="partner-section partner-form-section" id="influencer-form">
        <div className="partner-form-container">
          <div className="partner-form-intro">
            <h2>Apply to collaborate</h2>
            <p>Tell us about yourself and your community. We'll reach out if it's a good fit.</p>
          </div>
          {status === "success" ? (
            <div className="contact-success">
              <div className="contact-success-icon">✓</div>
              <h3>Application received!</h3>
              <p>Thanks for your interest. Our team will review and get back to you soon.</p>
              <button className="btn-primary" onClick={function() { setStatus(""); }}>Apply Again</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form partner-form">
              <div className="partner-form-row">
                <div className="form-group">
                  <label>Your Name</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Full name" />
                  {errors.name && <span className="field-error">{errors.name}</span>}
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
                  {errors.email && <span className="field-error">{errors.email}</span>}
                </div>
              </div>
              <div className="partner-form-row">
                <div className="form-group">
                  <label>Phone</label>
                  <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="10-digit mobile" />
                  {errors.phone && <span className="field-error">{errors.phone}</span>}
                </div>
                <div className="form-group">
                  <label>Primary Platform</label>
                  <select name="platform" value={form.platform} onChange={handleChange} className="cancel-reason-select">
                    <option value="">Select...</option>
                    <option value="Instagram">Instagram</option>
                    <option value="YouTube">YouTube</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Twitter/X">Twitter / X</option>
                    <option value="Blog">Blog</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div className="partner-form-row">
                <div className="form-group">
                  <label>Handle / Channel</label>
                  <input type="text" name="handle" value={form.handle} onChange={handleChange} placeholder="@yourhandle" />
                  {errors.handle && <span className="field-error">{errors.handle}</span>}
                </div>
                <div className="form-group">
                  <label>Follower Count</label>
                  <input type="text" name="followers" value={form.followers} onChange={handleChange} placeholder="e.g. 12,000" />
                  {errors.followers && <span className="field-error">{errors.followers}</span>}
                </div>
              </div>
              <div className="form-group">
                <label>Why do you want to collaborate?</label>
                <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your content and why PureJar resonates with you..." rows="4"></textarea>
              </div>
              {status === "error" && <p className="contact-error">Something went wrong. Please try again or email collabs@purejar.in.</p>}
              <button type="submit" className="btn-primary" disabled={sending}>{sending ? "Sending..." : "Submit Application"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
